import * as React from "react"

function SvgComponent(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={36.263}
      height={52.794}
      viewBox="0 0 36.263 52.794"
      {...props}
    >
      <path
        data-name="Path 7959"
        d="M29.704 52.02H6.56a2.48 2.48 0 01-2.48-2.48V3.253A2.48 2.48 0 016.56.773h23.144a2.48 2.48 0 012.48 2.48V49.54a2.48 2.48 0 01-2.48 2.48z"
        fill="#edebed"
      />
      <path
        data-name="Rectangle 759"
        fill="#ffe17d"
        d="M4.08 4.079h28.103v41.329H4.08z"
      />
      <path
        data-name="Path 7960"
        d="M17.717 42.102A10.332 10.332 0 017.385 31.77V4.08H4.079v41.328h28.1v-3.306z"
        fill="#ffd164"
      />
      <path
        data-name="Path 7961"
        d="M33.836 29.703H13.998a1.653 1.653 0 01-1.653-1.653V14.83a1.653 1.653 0 011.653-1.653h19.838a1.653 1.653 0 011.653 1.653v13.22a1.653 1.653 0 01-1.653 1.653z"
        fill="#ff8587"
      />
      <path
        data-name="Path 7962"
        d="M22.264 17.304h-9.919v10.745a1.653 1.653 0 001.653 1.653h12.4v-8.266a4.133 4.133 0 00-4.134-4.132z"
        fill="#e6646e"
      />
      <path
        data-name="Rectangle 760"
        fill="#5d5360"
        d="M12.346 16.479H35.49v3.306H12.346z"
      />
      <path
        data-name="Path 7963"
        d="M22.264 36.313H2.426A1.653 1.653 0 01.773 34.66V21.437a1.653 1.653 0 011.653-1.653h19.838a1.653 1.653 0 011.653 1.653v13.225a1.653 1.653 0 01-1.653 1.651z"
        fill="#ff8587"
      />
      <path
        data-name="Path 7964"
        d="M6.56 28.05h-.827a1.653 1.653 0 01-1.653-1.653 1.653 1.653 0 011.653-1.653h.827a1.653 1.653 0 011.653 1.653A1.653 1.653 0 016.56 28.05z"
        fill="#ffd164"
      />
      <path
        data-name="Path 7965"
        d="M18.958 28.05a1.653 1.653 0 01-1.653-1.653 1.653 1.653 0 011.653-1.653 1.653 1.653 0 011.653 1.653 1.653 1.653 0 01-1.653 1.653z"
        fill="#5d5360"
      />
      <path
        data-name="Path 7966"
        d="M15.651 28.05a1.653 1.653 0 01-1.653-1.653 1.653 1.653 0 011.653-1.653 1.653 1.653 0 011.653 1.653 1.653 1.653 0 01-1.653 1.653z"
        fill="#ae6c73"
      />
      <path
        data-name="Path 7967"
        d="M22.264 17.249h-9.919v2.536h13.7a4.129 4.129 0 00-3.781-2.536z"
        fill="#4b3f4e"
      />
      <path
        data-name="Path 7968"
        d="M4.081 17.251a.773.773 0 00.773-.773V3.253A1.708 1.708 0 016.56 1.547h23.144a1.708 1.708 0 011.706 1.706v6.613a.774.774 0 101.547 0V3.253A3.257 3.257 0 0029.703 0H6.559a3.257 3.257 0 00-3.253 3.253v13.225a.773.773 0 00.775.773z"
      />
      <path
        data-name="Path 7969"
        d="M29.651 45.408a.773.773 0 00-.773-.773H7.386a.774.774 0 100 1.547h21.491a.773.773 0 00.774-.774z"
      />
      <path
        data-name="Path 7970"
        d="M7.386 3.306a.774.774 0 100 1.547h21.491a.774.774 0 000-1.547z"
      />
      <path
        data-name="Path 7971"
        d="M17.304 47.941a.774.774 0 100 1.547h1.653a.774.774 0 100-1.547z"
      />
      <path
        data-name="Path 7972"
        d="M5.732 28.824h.827a2.426 2.426 0 100-4.853h-.827a2.426 2.426 0 100 4.853zm0-3.306h.827a.88.88 0 010 1.76h-.827a.88.88 0 010-1.76z"
      />
      <path
        data-name="Path 7973"
        d="M15.651 28.824a2.417 2.417 0 001.653-.652 2.426 2.426 0 100-3.548 2.426 2.426 0 10-1.653 4.2zm3.306-3.306a.88.88 0 010 1.76.881.881 0 01-.88-.879.881.881 0 01.881-.881zm-3.306 0a.881.881 0 01.88.879.88.88 0 11-.88-.881z"
      />
      <path
        data-name="Path 7974"
        d="M5.732 32.129a.774.774 0 000-1.547H4.08a.774.774 0 100 1.547z"
      />
      <path
        data-name="Path 7975"
        d="M13.998 32.129h1.653a.774.774 0 000-1.547h-1.653a.774.774 0 000 1.547z"
      />
      <path
        data-name="Path 7976"
        d="M8.266 31.355a.773.773 0 00.773.773h1.653a.774.774 0 100-1.547H9.044a.773.773 0 00-.778.774z"
      />
      <path
        data-name="Path 7977"
        d="M20.61 30.585h-1.653a.774.774 0 000 1.547h1.653a.774.774 0 000-1.547z"
      />
      <path
        data-name="Path 7978"
        d="M33.839 12.399H13.998a2.429 2.429 0 00-2.426 2.426v1.653a.773.773 0 00.773.773h22.371v1.76h-7.492a.774.774 0 100 1.547h7.492v7.492a.881.881 0 01-.88.88h-6.613a.774.774 0 100 1.547h4.186v19.064a1.708 1.708 0 01-1.706 1.706H6.559a1.708 1.708 0 01-1.706-1.706V37.09h17.411a2.429 2.429 0 002.426-2.426V21.438a2.429 2.429 0 00-2.426-2.426H2.426A2.429 2.429 0 000 21.438v13.225a2.429 2.429 0 002.426 2.426h.88v12.452a3.257 3.257 0 003.253 3.253h23.144a3.257 3.257 0 003.253-3.253V30.477h.883a2.429 2.429 0 002.426-2.426V14.825a2.429 2.429 0 00-2.426-2.426zM1.547 34.663V21.438a.881.881 0 01.88-.88h19.838a.881.881 0 01.88.88v13.225a.881.881 0 01-.88.88H2.426a.881.881 0 01-.879-.88zm11.572-18.958v-.88a.881.881 0 01.88-.88h19.84a.881.881 0 01.88.88v.88z"
      />
    </svg>
  )
}

const MemoSvgComponent = React.memo(SvgComponent)
export default MemoSvgComponent
